export default function getWindowSize() {
    let size = "XL";
    const width = window.innerWidth;
    const height = window.innerHeight;
    if (width <= 480) {
        size = "XS";
    } else if (width <= 768) {
        size = "S";
    } else if (width <= 1024) {
        size = "M";
    } else if (width <= 1366) {
        size = "L";
    }
    return { height, size, width };
}
